import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {ImportUserResultModal} from './import-user.result.modal';
import {
    clearResult,
    selectImportUserShown,
    selectImportUserTask,
    selectImportUserUuid,
} from './import-user.slice';


export const ImportUserResult = () => (
    <BulkActionResult
        actionIdSelector={selectImportUserUuid}
        actionTaskSelector={selectImportUserTask}
        actionShownSelector={selectImportUserShown}
        clearResult={clearResult}>
        {({id, onClose}) => <ImportUserResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
